import React, {FunctionComponent, useEffect, useState, Fragment} from 'react';
import QRCode from 'qrcode'
import {IQueryParams} from '../../../../types/IQueryParams';
import {UrlBuilder} from '../../../../utils/urlBuilder';
import {QR_TITLE} from '../../../../store/constants';
import LinksModal from '../LinksModal/LinksModal';
import EmailModal from '../EmailModal/EmailModal';
import QrCode from '../QrCode/QrCode';
import QrCodeControls from '../QrControls/QrCodeControls';
import {isFalse} from "../../../../utils/misc";
import {IBuilding} from "../../../../types/IBuilding";
import linksStore from '../../../../store/LinksStore/LinksStore';
import { observer } from 'mobx-react';
import {Routes} from "../../../../routes";
import {ChannelParam} from "../../../../store/QueryParamsStore/QueryParamsEnums";
import { analytics } from '../../../..';
import { AnalyticsEvents } from '../../../../store/AnalyticsStore';

interface IControlsRight {
    queryParams: IQueryParams;
    translateText: (id: number) => string;
    building?:IBuilding;
}

const ControlsRight: FunctionComponent<IControlsRight> = observer(({queryParams, translateText, building}) => {
    const {buildingId, nodeFrom, nodeTo, routeLang, WheelChair, MultiBuilding, homepage, fixStart} = queryParams;
    const {setLink, link} = linksStore;
    const [qr, setQr] = useState<string>('');
    const [linksModalOpen, setLinkModalOpen] = useState<boolean>(false);
    const [emailTemplateOpen, setEmailTemplateOpen] = useState<boolean>(false);

    useEffect(() => {
        const {homepage, channel, ...exceptHomePage} = queryParams;
        const builder = !!queryParams.urlRoot ?
            new UrlBuilder(queryParams.urlRoot) :
            UrlBuilder.Relative(Routes.PhotoRoute);

        builder.searchParams({...exceptHomePage});

        setLink(builder.url);
    }, [queryParams]);

    useEffect(() => {
        if(!link) return;

        const linkWithQRHomeChannel = new URL('', link);
        linkWithQRHomeChannel.searchParams.set('channel', ChannelParam.QRHome);

        QRCode.toDataURL(linkWithQRHomeChannel.href).then(qr => setQr(qr)).catch(e => console.error(e));
    }, [link]);

    if(!buildingId || !nodeFrom || !nodeTo || isFalse(homepage)) return null;

    return (
        <Fragment>
            <div className="col-md-6 border-leftside">
                <div className="ml-10">
                    <div className="row">
                        <QrCodeControls
                            qrTitle = {translateText(QR_TITLE)}
                            showEmailButton = {!!building && building.email}
                            onEmailClick = {() => {
                                analytics.logEvent(AnalyticsEvents.PressShareEmail)
                                setEmailTemplateOpen(true)
                            }}
                            onLinkClick = {() => {
                                analytics.logEvent(AnalyticsEvents.PressShareLink)

                                setLinkModalOpen(true)
                            }}
                        />
                        <QrCode src={qr}/>
                    </div>
                </div>
            </div>
            {linksModalOpen && <LinksModal onClose = {() => setLinkModalOpen(false)}/>}
            {emailTemplateOpen && <EmailModal onClose = {() => setEmailTemplateOpen(false)}/>}
        </Fragment>
    )
});

export default ControlsRight;
